import React from "react"

import { withGeneric } from "./withGeneric"
import { Page, Container, Title, Content } from "./GenericStyles"

export const Generic = withGeneric(
  ({ title, content }): JSX.Element => (
    <Page>
      <Container width={`lg`}>
        <Title>{title}</Title>
        <Content>{content}</Content>
      </Container>
    </Page>
  )
)
